import { httpApi } from '@api/http.api.ts';
import type { UserTypes } from '@routes/___shared___/user.api';

export interface PasswordPolicyResponse {
    id: number;
    name: string;
    description?: string | null;
    regexPattern?: string | null;
    passwordRequirementType: string;
    passwordRequirementValue: number;
}
export interface PasswordPolicyPerUserType {
    userType: UserTypes;
    passwordPolicies: PasswordPolicyResponse[];
}
export interface ClientStatusResponse {
    passwordPolicyPerType: PasswordPolicyPerUserType[];
    clientLogoURI: string;
}

export const getApiClientStatus = (): Promise<ClientStatusResponse> =>
    httpApi.get<ClientStatusResponse>(`status`).then(({ data }) => data);
